/**
 * Created by Suhel Shrestha on 2/25/19
 */
import React, { PropTypes } from 'react';
import { inject, observer } from "mobx-react/index";
import Form, { DateInput, FormActions, FormBody, SelectInput } from "../../Form";
import { action, autorunAsync, observable } from "mobx/lib/mobx";
import moment from "moment/moment";
import Spinner from "../../Spinner";
import { toJS } from "mobx";

@inject('stationStore', 'dataSeriesStore', 'aggregationStore', 'parameterStore')
@observer
export default class StationManualAggregation extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };


  @observable station = {};
  @observable dataSeriesItems = [];

  dispose;

  componentWillMount() {
    const { params: { id }, stationStore, dataSeriesStore, parameterStore } = this.props;
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    // this.dispose = autorunAsync(() => {
    // dataSeriesStore.fetchItems();
    stationStore.fetchDataSeries(id).then(items => {
      this.resetDataSeriesItems(items)
    });
    // });
  }

  componentWillUnmount() {
    const { aggregationStore } = this.props;
    // this.dispose();
    if (!aggregationStore.loading) aggregationStore.resetFilters();
  }

  @action resetDataSeriesItems(item) {
    if (!item) {
      return;
    }
    // this.station = item.asJson;
    const { parameterStore } = this.props;
    this.dataSeriesItems = item.filter(item => item.table === 1).map(item => (Object.assign(item, { parameter: parameterStore.findById(item.parameter_id) })));
  }

  startManualAggregation = e => {
    e.preventDefault();
    const { aggregationStore } = this.props;
    const { notify } = this.context;
    aggregationStore.loading = true;
    aggregationStore.runManualAggregation(aggregationStore.filters).then(res => {
      aggregationStore.loading = false;
      console.log(res)
      notify.success(res);
    }).catch(err => {
      console.error(err);
      notify.error(err);
      aggregationStore.loading = false;
    })
  };

  render() {
    const { aggregationStore, parameterStore } = this.props;
    // console.log(toJS(aggregationStore.filters))
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='DataSeries' value={aggregationStore.filters.series_id} fields={{ label: 'name', value: 'id' }} options={this.dataSeriesItems} onChange={aggregationStore.onChangeSeries} filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')} />
            <DateInput label='Date From' type='datetime-local' value={aggregationStore.filters.date_from} onChange={aggregationStore.onChangeDateFrom} />
            <DateInput label='Date To' type='datetime-local' value={aggregationStore.filters.date_to} onChange={aggregationStore.onChangeDateTo} />
          </FormBody>
          <FormActions>
            <button onClick={this.startManualAggregation}>Run Aggregation</button>
          </FormActions>
        </Form>
        {/*{aggregationStore.loading && <Spinner/>}*/}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Station/Aggregation/StationManualAggregation.js